<section class="curation-editor-wrapper" *ngIf="isDataLoaded">
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <section>
    <gen-curation-editor-actions
      [curationStatus]="curationStatus"
      [curationKey]="curationKey"
      [approvalUserMode]="approvalUserMode"
      [publishUserMode]="publishUserMode"
      [curatorUserMode]="curatorUserMode"
      [isAssignee]="isCurationItemAssignedToCurrentUser"
      [buttonsDisabled]="actionsDisabledMode"
      [curationItem]="curationItem"
      [oldRevisionMessage]="oldRevisionMessage"
      [readOnlyUserMode]="readOnlyUserMode"
      [multiStepReview]="multiStepReview"
      [evidence]="evidence"
      [searchDataConfigParams]="searchDataConfigParams"
      [searchFormConfigParams]="searchFormConfigParams"
      [curationDataForSearch]="curationDataForSearch"
      [googleSearchURL]="googleSearchURL"
      [pubmedSearchURL]="pubmedSearchURL"
      [newNotes]="newNotes"
      [reassignButtonDisabled]="isReassignButtonDisabled"
      [historyData]="revisionsData"
      (statusChanged)="changeStatus($event.status)"
      (statusChangedToRejected)="reject()"
      (goBackEvent)="goBack(true)"
      (notesPanelToggled)="toggleNotesPanel()"
      (toggleReassignCurationItem)="reassignCurationItem()"
      (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
      [sameOrganization]= "sameOrganization"

    >
    </gen-curation-editor-actions>
    <gen-panel
            name="CURATION-NOTES-PANEL"
            class="{{notesPanelClass}}"
            (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
    </gen-panel>
  </section>
  <section class="scrollable">
    <section class="curation-editor-content" *ngIf="isDataLoaded">
      <gen-curation-editor-aberration-data
        [curationItem]="curationItem"
        [readOnly]="readOnlyMode"
        [inlineEdit]="inlineEdit"
        [curationKey]="curationKey"
        (validated)="itemValidationEvent($event)"
        (itemDeleted)="deleteItem($event)"
        [submitted]="submitted"
        [approvedMode]="approvedMode"
        [revisionTag]="revisionTag"
        [summaryFormName]="summaryFormName"
        [aberrationDetailsFormName]="aberrationDetailsFormName"
        [diagnosticFormName]="diagnosticFormName"
        [prognosticFormName]="prognosticFormName"
        [therapeuticFormName]="therapeuticFormName"
        [clinicalTrialsFormName]="clinicalTrialsFormName"
        [searchDataConfigParams]="searchDataConfigParams"
        [casesFormName]="casesFormName"
        [pubmedFormName]="pubmedFormName"
        [verticalForm] = "aberrationDataVerticalForm"
        [googleSearchURL]="googleSearchURL"
        [pubmedSearchURL]="pubmedSearchURL"
        (aberrationDataChanged)="aberrationDataChangedEvent($event)"
      >
      </gen-curation-editor-aberration-data>
    </section>
  </section>
</section>
